<template>
  <div>
   <table
  role="table"
  style="width: 99%"
  cellspacing="4mm"
  cellpadding="0"
  class="customers"
>
  <thead role="rowgroup">
    <tr role="row">
      <!-- <th role="columnheader">Sr.No.</th> -->
      <!-- <th role="columnheader">Order ID</th> -->
      <!-- <th role="columnheader">Transaction Date</th> -->
      <!-- <th role="columnheader">Screening Date</th> -->
      <!-- <th role="columnheader">Showtime</th> -->
      <!-- <th role="columnheader">Email ID</th> -->
      <!-- <th role="columnheader">Mobile Number</th> -->
      <!-- <th role="columnheader">Showbizz Receipt Number / Booking ID</th> -->
      <!-- <th role="columnheader">Pick Up Code</th> -->
      <!-- <th role="columnheader">Movie Name</th> -->
      <!-- <th role="columnheader">Cinema Name</th> -->
      <!-- <th role="columnheader">Number of Seats</th> -->
      <!-- <th role="columnheader">Name of Seats</th> -->
      <!-- <th role="columnheader">Amount</th> -->
      <!-- <th role="columnheader">Discount</th> -->
      <!-- <th role="columnheader">Offer Name</th> -->
      <!-- <th role="columnheader">RRN</th> -->
      <th role="columnheader">Booking Status</th>
      <th role="columnheader">Payment Status</th>
      <!-- <th role="columnheader">Showbizz Status</th> -->
      <!-- <th role="columnheader">Card Number</th> -->
      <!-- <th role="columnheader">Card Type</th> -->
      <!-- <th role="columnheader">Refund Date/Time</th> -->
      <!-- <th role="columnheader">Paymentgateway remark</th> -->
      <th role="columnheader">Refund Status</th>
      <!-- <th role="columnheader">Aquirer Code</th> -->
      <!-- <th role="columnheader">Aquirer Description</th> -->
    </tr>
  </thead>
  <tbody role="rowgroup">
    <tr role="row" style="background-color: #de950f !important">
      <!-- <td role="cell">1</td> -->
      <!-- <td role="cell">1272502</td> -->
      <!-- <td role="cell">2022-06-06</td> -->
      <!-- <td role="cell">2022-06-06</td> -->
      <!-- <td role="cell">18:30:00</td> -->
      <!-- <td role="cell">Rayansaud01@hotmail.com</td> -->
      <!-- <td role="cell">547999012</td> -->
      <!-- <td role="cell">To be refunded</td> -->
      <!-- <td role="cell">3335</td> -->
      <!-- <td role="cell">WAHED TANY</td> -->
      <!-- <td role="cell">Jeddah - AlAndalus Mall</td> -->
      <!-- <td role="cell">H8,H9</td> -->
      <!-- <td role="cell">2</td> -->
      <!-- <td role="cell">126</td> -->
      <!-- <td role="cell">0</td> -->
      <!-- <td role="cell">-</td> -->
      <!-- <td role="cell">215900127621</td> -->
      <td role="cell">{{transactionsList.booking_status}}</td>
      <td role="cell">{{transactionsList.payment_status}}</td>
      <!-- <td role="cell">FAILED</td> -->
      <!-- <td role="cell">405433xxxxxx9159</td> -->
      <!-- <td role="cell">VISA</td> -->
      <!-- <td role="cell">08-06-2022</td> -->
      <!-- <td role="cell">REFUNDED</td> -->
      <td role="cell">{{transactionsList.vistaNewRefundStatus}}</td>
      <!-- <td role="cell"></td> -->
      <!-- <td role="cell"></td> -->
    </tr>
  </tbody>
</table>

   
  </div>
</template>

<script>
import TransactionServices from "@/apiServices/TransactionServices";
import ViewTransaction from "./ViewTransaction";
import GeneralServices from "@/apiServices/GeneralServices";
import { getFormattedDate } from "@/helpers/formatters";
import CinemaServices from "@/apiServices/CinemaServices";
import XLSX from "xlsx";

export default {
  name: "TransactionsList",
  components: {
    ViewTransaction
  },
  data() {

    name: "data"
    return {
      // View
      viewVisible: false,
      viewObject: undefined,
      // View End
      //
      transactionsList: null,
     
    };
  },
  beforeMount() {
    this.getTransaction();
    // this.getCountries();
    // // this.getCities();
    // this.getCinema();
    // this.getPaymentOptions();
  },
  watch: {
    "filters.country_id": function(val, oldVal) {
      this.filters.city_id = undefined;
      this.filters.cinema_id = undefined;
      if (!val) {
        // this.cities = [...this.all_cities]
        this.cinemas = [...this.all_cinemas];
        this.payment_options = [...this.all_payment_options];
      } else {
        // this.cities = this.all_cities.filter(city => city.country_id === val);
        this.cinemas = this.all_cinemas.filter(
          cinema => cinema.country_id == val
        );
        this.payment_options = this.all_payment_options.filter(
          pg => pg.country_id === val
        );
      }
    }
  },
  methods: {
   
    async getTransaction() {
    // console.log(this.$route.params.id , "DSAFKADSJLFADSJFKADSJF") 
      try {
        this.loading = true;
        this.transactionsList = [];
        const response = await TransactionServices.GetSpacificTransaction({
         transaction_id : this.$route.params.id
        });
        const { data } = response;
        this.transactionsList = data.data[0]
        console.log(this.transactionsList, "UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU")

          if(this.transactionsList.payment_status == "Confirmed" && this.transactionsList.booking_status == "Confirmed"){
           this.transactionsList.vistaNewRefundStatus = "Not Refund Case"
        //    item.vista_status = "Booked"
         }else if(this.transactionsList.booking_status == "Not Performed" && this.transactionsList.payment_status == "Cancelled"){
           this.transactionsList.vistaNewRefundStatus = "Not Refund Case"
        //    item.vista_status = "Not Booked"
         }else if(this.transactionsList.booking_status == "Unconfirmed" && this.transactionsList.payment_status == "Unconfirmed"){
           this.transactionsList.vistaNewRefundStatus = "Not Refund Case"
        //    item.vista_status = "Not Booked"
         }else if(this.transactionsList.booking_status == "Cancelled" && this.transactionsList.payment_status == "Cancelled"){
            this.transactionsList.vistaNewRefundStatus = "Not Refund Case"
        //    item.vista_status = "Not Booked"
         }

          if(this.transactionsList.booking_status == "Failed" && this.transactionsList.payment_status == "Confirmed"){
           item.refund_status = "Refund Case"
        //    item.vista_status = "Not Booked"
         }else if(this.transactionsList.booking_status == "Failed" && this.transactionsList.payment_status == "Refunded"){
           item.refund_status = "Refund Case"
        //    item.vista_status = "Not Booked"
         }
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    
    
  }
};
</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
